export default __webpack_public_path__ + "static/media/euro2024.e5bc841a.webp";